import { Icon } from '@boltenergy-be/design-system'
import { RatingScoreProps } from './types'
import styles from './Score.module.scss'
import { memo, useMemo } from 'react'
import { REVIEWS } from 'components/review-ratings/Constants'
import { isBilingualText } from 'components/review-ratings/components/utils'
import { useGetLanguage } from 'hooks/useGetLanguage'

const Score = memo(({ maxScore = 5, instance, logoProps }: RatingScoreProps) => {
  // i18n
  const language = useGetLanguage()

  // Constants
  const { logo, score, label } = useMemo(() => REVIEWS[instance], [instance])

  return (
    <strong data-instance={instance} className={styles.rating}>
      <span className={styles.logo}>{logo(logoProps)}</span>
      <span className={styles.rating}>
        {score === maxScore ? score : score.toFixed(1).replace('.', ',')} <Icon name="star" size={16} />
      </span>{' '}
      {isBilingualText(label) ? label[language] : label}
    </strong>
  )
})

Score.displayName = 'Score'

export default Score
